import React from 'react';

const CloudIcon = ({ size = 24, color = 'currentColor', ...props }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      {...props}
    >
      <path 
        d="M15.0001 3.75C13.4679 3.75118 11.9663 4.17857 10.6631 4.98437C9.35997 5.79017 8.30667 6.94262 7.62103 8.31281C6.80536 8.19385 5.97394 8.24424 5.17861 8.46082C4.38328 8.67741 3.64111 9.05555 2.99839 9.57166C2.35567 10.0878 1.82618 10.7308 1.44297 11.4606C1.05975 12.1904 0.831014 12.9913 0.771033 13.8134C0.711053 14.6355 0.82111 15.4612 1.09434 16.2388C1.36757 17.0165 1.79812 17.7296 2.35912 18.3335C2.92012 18.9375 3.59955 19.4193 4.35502 19.749C5.11049 20.0788 5.9258 20.2493 6.75009 20.25H15.0001C17.1881 20.25 19.2865 19.3808 20.8337 17.8336C22.3809 16.2865 23.2501 14.188 23.2501 12C23.2501 9.81196 22.3809 7.71354 20.8337 6.16637C19.2865 4.61919 17.1881 3.75 15.0001 3.75ZM15.0001 18.75H6.75009C5.55661 18.75 4.41202 18.2759 3.56811 17.432C2.72419 16.5881 2.25009 15.4435 2.25009 14.25C2.25009 13.0565 2.72419 11.9119 3.56811 11.068C4.41202 10.2241 5.55661 9.75 6.75009 9.75C6.85321 9.75 6.95634 9.75 7.05853 9.76031C6.85342 10.4892 6.74963 11.2428 6.75009 12C6.75009 12.1989 6.82911 12.3897 6.96976 12.5303C7.11041 12.671 7.30118 12.75 7.50009 12.75C7.699 12.75 7.88977 12.671 8.03042 12.5303C8.17107 12.3897 8.25009 12.1989 8.25009 12C8.25009 10.665 8.64597 9.35993 9.38767 8.2499C10.1294 7.13987 11.1836 6.2747 12.417 5.76381C13.6504 5.25292 15.0076 5.11925 16.3169 5.3797C17.6263 5.64015 18.8291 6.28302 19.7731 7.22703C20.7171 8.17103 21.3599 9.37377 21.6204 10.6831C21.8808 11.9925 21.7472 13.3497 21.2363 14.5831C20.7254 15.8165 19.8602 16.8707 18.7502 17.6124C17.6402 18.3541 16.3351 18.75 15.0001 18.75Z" 
        fill={color}
      />
    </svg>
  );
};

export default CloudIcon;

